import * as React from "react";
import { House, Building2, CloudLightning, ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const expertiseData = [{
  title: "Lighting & Fan Installation",
  description: "Enhance your living space with expert lighting designs and professional ceiling fan mounting. We ensure every fixture is installed safely and functions perfectly for your comfort.",
  icon: House,
  link: "/ResidentialPage"
}, {
  title: "Electrical Panel Upgrades",
  description: "Modernize your home's electrical core with high-capacity panel replacements and circuit upgrades. We provide the reliable power infrastructure needed for today's high-demand appliances.",
  icon: Building2,
  link: "/ResidentialPage"
}, {
  title: "24/7 Emergency Repairs",
  description: "Rapid response for electrical failures, sparking outlets, or power outages in Richmond and surrounding areas. Our family-owned team is ready 24/7 to restore safety to your home.",
  icon: CloudLightning,
  link: "/ContactPage"
}];
export default function OurRoofingExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="31863" id="our-residential-expertise" ref={ref} className={cn("bg-background text-foreground py-20 lg:py-32 transition-opacity duration-700", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-[60px]">
          {expertiseData.map((item, i) => <Card key={i} data-index={i} className="group bg-white border border-border hover:border-primary hover:shadow-xl transition-all duration-400 rounded-sm h-full flex flex-col">
              <CardHeader className="pt-8 px-8 pb-4">
                <div className="mb-6 inline-flex items-center justify-center">
                  <item.icon strokeWidth={2} className="w-12 h-12 text-primary group-hover:scale-110 transition-transform duration-400" />
                </div>
                <CardTitle className="font-sans text-2xl font-bold text-foreground tracking-tight">
                  {item.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="px-8 pb-8 flex-grow">
                <p className="font-sans text-muted-foreground leading-relaxed">
                  {item.description}
                </p>
              </CardContent>
              <CardFooter className="px-8 pb-8 pt-0">
                
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}